import type { TransactionLocation, TransactionLocationFilterField, UsherTransactionLocation } from '@/generated/graphql';

export interface ITransactionLocation {
  id: string;
  latitude: number;
  longitude: number;
  createdAt: string;
  updatedAt: string;
}

export interface IUsherTransactionLocation {
  id: string;
  latitude: number;
  longitude: number;
  datetime: string;
  name: string;
  username: string;
  transactionCode: string;
}

export interface IUsherTransactionLocationQueryVariable {
  filterBy?: TransactionLocationFilterField;
  first: number;
  after?: string;
  before?: string;
}

export function mapGQLTransactionLocation(transactionLocation?: TransactionLocation | null): ITransactionLocation {
  return {
    id: transactionLocation?.id ?? '',
    latitude: transactionLocation ? transactionLocation.latitude ?? 0 : 0,
    longitude: transactionLocation ? transactionLocation.longitude ?? 0 : 0,
    createdAt: transactionLocation ? transactionLocation.createdAt ?? new Date().toISOString() : new Date().toISOString(),
    updatedAt: transactionLocation ? transactionLocation.updatedAt ?? new Date().toISOString() : new Date().toISOString(),
  };
}

export function mapGQLUsherTransactionLocation(transactionLocation?: UsherTransactionLocation | null): IUsherTransactionLocation {
  return {
    id: transactionLocation?.id ?? '',
    latitude: transactionLocation ? transactionLocation.latitude ?? 0 : 0,
    longitude: transactionLocation ? transactionLocation.longitude ?? 0 : 0,
    datetime: transactionLocation ? transactionLocation.datetime ?? new Date().toISOString() : new Date().toISOString(),
    name: transactionLocation ? transactionLocation.name ?? '' : '',
    username: transactionLocation ? transactionLocation.username ?? '' : '',
    transactionCode: transactionLocation ? transactionLocation.transactionCode ?? '' : '',
  };
}
